import TableContainer from './TableContainer.js';

export default TableContainer;